import { createContext, createRef, RefObject } from "react";

export interface ModalContextType {
    modalContainer: RefObject<HTMLDivElement>;
};

export const ModalContext = createContext<ModalContextType>({
    modalContainer: createRef<HTMLDivElement>()
});